import { render, staticRenderFns } from "./invoicetype.vue?vue&type=template&id=00618262&"
import script from "./invoicetype.vue?vue&type=script&lang=ts&"
export * from "./invoicetype.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports